import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, ConfigState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type ConfigGetter = GetterTree<ConfigState, RootState>

const state: ConfigState = {
  /*
  PROPOSITION OPTIONS
  */
  propositionOptions: null,
  propositionOption: null
}

export const getters: ConfigGetter = {
  /*
  PROPOSITION OPTIONS
  */
  propositionOptionsGetter: (state) => state.propositionOptions,
  propositionOptionGetter: (state) => state.propositionOption
}

export const actions: ActionTree<ConfigState, RootState> = {
  /*
  PROPOSITION OPTIONS
  */
  async getPropositionOptionsAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/option`, {
      params: {
        ...queryParams
      }
    })
    commit('getPropositionOptionsMutation', data)
    return data
  },
  async getPropositionOptionByIdAction({commit}, id) {
    commit('resetPropositionOptionMutation')
    const {data} = await axios.get(`${apiUrl}/option/${id}`)
    commit('getPropositionOptionByIdMutation', data)
    return data
  },
  async createPropositionOptionAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/option`, formParams)
    return data
  },
  async updatePropositionOptionAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/option/${id}`, formParams)
    return data
  },
  async deletePropositionOptionAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/option/${id}`)
    return id
  },
  async syncPropositionOptionAction({commit}, syncData) {
    const {data} = await axios.post(`${apiUrl}/option/sync`, {data: syncData})
    return data
  }
}

const mutations: MutationTree<ConfigState> = {
  /*
  PROPOSITION OPTIONS
  */
  getPropositionOptionsMutation(state, data) {
    state.propositionOptions = data
  },
  getPropositionOptionByIdMutation(state, data) {
    state.propositionOption = data
  },
  resetPropositionOptionMutation(state) {
    state.propositionOption = null
  }
}

export const config: Module<ConfigState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
